import css from "../Form.module.css";
import { useRef, useState, useEffect } from "react";
import SvgOptions from "../../Svg/SvgOptions";
import Svg from "../../Svg/Svg";

const Password = ({ children, onChange }) => {
	const { label, name, placeholder, value, required, disabled, inputRef } =
		children;

	const id = "id" + Date.now() + Math.random() * 1000;
	const internalRef = useRef();
	const ref = inputRef ?? internalRef;

	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		if (ref.current) {
			ref.current.value = value || "";
		}
	}, [value]);

	useEffect(() => {
		if (ref.current) {
			ref.current.value = value || "";
		}
	}, [children]);

	const handleChange = () => {
		children.value = ref.current.value;
		if (onChange) onChange();
	};

	const toggleVisibility = () => {
		setIsVisible((prev) => !prev);
	};

	return (
		<div className={css.FormControl}>
			<div>
				<label htmlFor={id}>{label}</label>
			</div>
			<div className={css.PasswordContainer}>
				<input
					id={id}
					name={name}
					type={isVisible ? "text" : "password"}
					placeholder={placeholder}
					required={!!required}
					disabled={!!disabled}
					autoComplete="off"
					ref={ref}
					defaultValue={value}
					onChange={handleChange}
				/>
				<span
					className={css.ToggleVisibilityIcon}
					onClick={toggleVisibility}
					tabIndex={0}
				>
					{isVisible ? (
						<Svg>{SvgOptions.Visible}</Svg>
					) : (
						<Svg>{SvgOptions.VisibleOff}</Svg>
					)}
				</span>
			</div>
		</div>
	);
};

export default Password;
